import { jsx as _jsx } from "react/jsx-runtime";
import CloseFilled16 from '@carbon/icons-react/es/close--filled/16';
import { Button } from '@rocketlane/ui';
// Ported from the former styled(Button): a 16x16 absolutely-positioned
// round close button that turns red on hover.
const CLOSE_BUTTON_CLASS = 'cp-absolute cp-top-[2px] cp-right-[2px] cp-z-0 cp-h-[16px] cp-w-[16px] cp-min-w-[16px] cp-rounded-full cp-p-0 hover:cp-text-[var(--error-color)] hover:cp-border-[var(--error-color)]';
export const CloseButton = ({ className, ...props })=>/*#__PURE__*/ _jsx(Button, {
        variant: "secondary",
        size: "medium",
        type: "button",
        leftIcon: /*#__PURE__*/ _jsx(CloseFilled16, {}),
        className: [
            CLOSE_BUTTON_CLASS,
            className
        ].filter(Boolean).join(' '),
        ...props
    });
